import { useState } from 'react';
import { publicUrl, STATUS_LABEL, type BlockInfo, type ImageRow } from './data';

const PILL_CLASS: Record<ImageRow['status'], string> = {
  placed: 'lp-tag lp-tag--good',
  missing: 'lp-tag lp-tag--bad',
  redo: 'lp-tag lp-tag--warn',
  retired: 'lp-tag',
};

export function StatusPill({ status }: { status: ImageRow['status'] }) {
  return <span className={PILL_CLASS[status]}>{STATUS_LABEL[status]}</span>;
}

/** The picture, or a gray box when there is none to show. */
export function Thumb({ row, version, large }: { row: ImageRow; version?: string | number | null; large?: boolean }) {
  const [broken, setBroken] = useState(false);
  const hasFile = row.status !== 'missing' && !broken;
  const cls = large ? 'il-thumb il-thumb--large' : 'il-thumb';
  if (!hasFile) {
    return (
      <div className={`${cls} il-thumb--empty`} aria-label="No file yet" role="img">
        <span>No file yet</span>
      </div>
    );
  }
  return (
    <div className={cls}>
      <img src={publicUrl(row, version)} alt="" loading="lazy" onError={() => setBroken(true)} />
    </div>
  );
}

export function IllustrationCard({
  row, moduleTitle, block, version, onOpen,
}: {
  row: ImageRow;
  moduleTitle: string;
  block: BlockInfo | null;
  version?: string | number | null;
  onOpen: (row: ImageRow) => void;
}) {
  const lesson = block?.lessonTitle || row.lesson_id || '';
  return (
    <button type="button" className="il-card" onClick={() => onOpen(row)}>
      <Thumb row={row} version={version} />
      <div className="il-card-body">
        <div className="il-card-top">
          <code className="il-filename">{row.filename}</code>
          <StatusPill status={row.status} />
        </div>
        <div className="il-card-where">
          {moduleTitle || row.module_id || 'Not placed in a lesson'}
          {lesson ? <> › {lesson}</> : null}
        </div>
        <div className="il-card-caption">{block?.caption || (block ? '' : 'Loading the caption…')}</div>
      </div>
    </button>
  );
}
